import DOMPurify from 'dompurify';

/**
 * Filtert HTML Content, um XSS Angriffe zu verhindern.
 * Erlaubt bestimmte Tags wie iframes für YouTube/Maps und SVGs.
 */
export const sanitizeHtml = (htmlContent) => {
  if (typeof htmlContent !== 'string') return htmlContent;
  
  return DOMPurify.sanitize(htmlContent, {
    // Erlaube iframes (für Karten/Videos) und SVG Elemente (für Icons)
    ADD_TAGS: ['iframe', 'style', 'svg', 'path', 'circle', 'line', 'polyline', 'rect'],
    ADD_ATTR: [
      'allow', 'allowfullscreen', 'frameborder', 'scrolling', 
      'viewBox', 'fill', 'stroke', 'strokeWidth', 'strokeLinecap', 'strokeLinejoin', 
      'd', 'cx', 'cy', 'r', 'x', 'y', 'width', 'height', 'rx', 'ry', 'x1', 'y1', 'x2', 'y2', 'points',
      'target', 'rel'
    ]
  });
};
